const schemaBoiler = {
    Type: null,
    Name: null,
    CustomValues: [],
    Label: "",
    RepeatGroup: false,
    Required: false,
    RequiredPhoto: false,
    RequiredPhotoMultimediaAssetId: null,
    Value: null,
    //delete on form save
    Position: null,
    Formatter: null,
    Validator: null,
    ReferenceName: null,
    LinkMap: [],
    CustomDropDown: false
}
export default schemaBoiler